import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import Typography from '../../typography'

import Eye from '../../icon/eye.svg'
import Calendar from '../../icon/calendar.svg'

const Body = ({ webinar, ...attrs }) => {
  const beginTime = moment(webinar.beginTime)

  return <div
    className={'p-4'}>
    {/* <Link */}
    {/* href={`/webinars/${webinar.id}/${webinar.meta.slug}`}> */}
    <div
      className={'block w-full mb-3'}
      style={{
        borderRadius: '0 1.5rem 1.5rem 1.5rem'
      }}>

      <Typography
        size={'four'}
        weight={'black'}
        clamp={2}
        style={{
          minHeight: '56px'
        }}>
        {webinar.title}
      </Typography>
    </div>
    {/* </Link> */}
    <div
      className={
        classNames([
          'flex',
          'flex-row',
          'items-center'
        ])
      }>
      <Calendar
        width={16}
        height={16}
        className={'mr-2'} />

      <Typography
        size={'two'}
        weight={'regular'}
        className={'mr-4'}>
        {beginTime.format('DD [de] MMM [de] YYYY')}
      </Typography>

      <Eye
        width={16}
        height={16}
        className={'mr-2'} />

      <Typography
        size={'two'}
        weight={'regular'}>
        {webinar.views}
        {' '}
        vistas
      </Typography>
    </div>
  </div>
}

Body.propTypes = {
  webinar: PropTypes.object
}

export default Body
